module.exports = __webpack_public_path__ + "img/fourth_cloud.f922acc7.png";